import { Header, Space, Spacer, TextLoader } from '@procurify/ui'

import { type IAuditLogRecordProps } from './AuditLogRecord'
import { AuditLogRecordStyled } from './styles/AuditLogRecordStyled'

export const AuditLogRecordLoader = ({
  headingLevel = 'h5',
}: Pick<IAuditLogRecordProps, 'headingLevel'>) => {
  return (
    <AuditLogRecordStyled status='Cancelled'>
      <Space size='xsmall'>
        <Header as={headingLevel}>
          <TextLoader width={150} />
        </Header>

        <TextLoader width={300} />
      </Space>

      <Spacer />

      <Space size='small'>
        <TextLoader width={100} />
        <Space direction='horizontal'>
          <TextLoader width={125} />
          <TextLoader width={125} />
        </Space>
      </Space>
    </AuditLogRecordStyled>
  )
}
